<!-- Welcome -->
<div class="welcome-card">
    <div>
        <h2 style="font-weight: normal;">Welcome Back, <span style="font-weight: 600;">{{user.name}}</span>
            ({{user.position}})</h2>
        <p>Manage your classes, students, attendance and assignments efficiently.</p>
    </div>

    <button class="btn btn-primary">
        <i class="bi bi-plus-circle"></i>
        Create Assignment
    </button>
</div>

<!-- Stats -->
<div class="row g-3 mt-0">
    <div class="col-md-6 col-xl-3">
        <div class="kpi-card">
            <div class="kpi-header">
                <div>
                    <span>Total Employees</span>
                    <h2>285</h2>
                </div>
                <div class="kpi-icon bg-primary">
                    <i class="bi bi-people-fill"></i>
                </div>
            </div>

            <div class="kpi-footer">
                <span class="text-success">
                    <i class="bi bi-arrow-up"></i> 12%
                </span>
                vs last month
            </div>

            <div class="progress mt-2">
                <div class="progress-bar bg-primary" style="width:85%"></div>
            </div>
        </div>
    </div>

    <div class="col-md-6 col-xl-3">
        <div class="kpi-card">
            <div class="kpi-header">
                <div>
                    <span>Present Today</span>
                    <h2>268</h2>
                </div>
                <div class="kpi-icon bg-success">
                    <i class="bi bi-calendar-check"></i>
                </div>
            </div>

            <div class="kpi-footer">
                Attendance Rate 74%
            </div>

            <div class="progress mt-2">
                <div class="progress-bar bg-success" style="width:74%"></div>
            </div>
        </div>
    </div>

    <div class="col-md-6 col-xl-3">
        <div class="kpi-card">
            <div class="kpi-header">
                <div>
                    <span>Open Positions</span>
                    <h2>18</h2>
                </div>
                <div class="kpi-icon bg-warning">
                    <i class="bi bi-person-plus-fill"></i>
                </div>
            </div>

            <div class="kpi-footer">
                42 Applications Pending
            </div>

            <div class="progress mt-2">
                <div class="progress-bar bg-warning" style="width:65%"></div>
            </div>
        </div>
    </div>

    <div class="col-md-6 col-xl-3">
        <div class="kpi-card">
            <div class="kpi-header">
                <div>
                    <span>Payroll Processed</span>
                    <h2>96%</h2>
                </div>
                <div class="kpi-icon bg-danger">
                    <i class="bi bi-cash-stack"></i>
                </div>
            </div>

            <div class="kpi-footer">
                ₹18.2 Lakh This Month
            </div>

            <div class="progress mt-2">
                <div class="progress-bar bg-danger" style="width:96%"></div>
            </div>
        </div>
    </div>
</div>

<div class="row g-3 mt-0">
    <div class="col-xl-4 col-md-6">
        <div class="dashboard-card p-3">
            <h5><i class="bi bi-file-earmark-text"></i> Leave Summary</h5>
            <hr class="mt-0">
            <div class="leave-widget">
                <div class="leave-item">
                    <div class="text-secondary">
                        <i class="bi bi-file-earmark-break-fill me-2"></i>
                        <span>Pending</span>
                    </div>
                    <span class="badge text-bg-secondary">12</span>
                </div>

                <div class="leave-item">
                    <div class="text-success">
                        <i class="bi bi-file-earmark-check-fill me-2"></i>
                        <span>Approved</span>
                    </div>
                    <span class="badge text-bg-success">48</span>
                </div>

                <div class="leave-item">
                    <div class="text-danger">
                        <i class="bi bi-file-earmark-excel-fill me-2"></i>
                        <span>Rejected</span>
                    </div>
                    <span class="badge text-bg-danger">4</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4 col-md-6">
        <div class="dashboard-card p-3">
            <h5><i class="bi bi-journal-check"></i> Attendance</h5>
            <hr class="mt-0">
            <div class="widget-card">
                <!-- <div class="attendance-circle">
                    96%
                </div> -->
                <div class="donut-chart" style="--percentage: 85%;">
                    <span class="center-text">85%</span>
                </div>
                <div class="text-center mt-3">
                    Staff Present Today
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4 col-md-6">
        <div class="dashboard-card p-3">
            <h5><i class="bi bi-calendar3"></i> Daily Activity Log</h5>
            <hr class="mt-0">
            <div class="activity-item">
                <i class="bi bi-check2-square"></i>
                New Teacher Joined
            </div>

            <div class="activity-item">
                <i class="bi bi-check2-square"></i>
                Leave Approved
            </div>

            <div class="activity-item">
                <i class="bi bi-check2-square"></i>
                Fee Collection Updated
            </div>
        </div>
    </div>

    <div class="col-xl-4 col-md-6">
        <div class="dashboard-card p-3" style="min-height: 250px;">
            <h5><i class="bi bi-check2-square"></i> Todo List</h5>
            <hr class="mt-0">
            <app-todo [stats]="false"  [title]="false"></app-todo>
        </div>
    </div>
    <div class="col-xl-4 col-md-6">
        <div class="dashboard-card p-3">
            <h5><i class="bi bi-card-checklist"></i> Complaints</h5>
            <hr class="mt-0">
            <ul class="mb-0">
                <li>Payroll Processing - Tomorrow</li>
                <li>Recruitment Drive - Friday</li>
                <li>Annual Evaluation - Next Week</li>
                <li>Payroll Processing - Tomorrow</li>
                <li>Recruitment Drive - Friday</li>
            </ul>
        </div>
    </div>
    <div class="col-xl-4 col-md-6">
        <div class="dashboard-card p-3">
            <h5><i class="bi bi-alarm"></i> Reminders</h5>
            <hr class="mt-0">
            <ul class="mb-0">
                <li>Payroll Processing - Tomorrow</li>
                <li>Recruitment Drive - Friday</li>
                <li>Annual Evaluation - Next Week</li>
                <li>Payroll Processing - Tomorrow</li>
                <li>Recruitment Drive - Friday</li>
            </ul>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-xl-12">
        <div class="dashboard-card p-3 mt-3">
            <div class="d-flex justify-content-between mb-2">
                <h5><i class="bi bi-clipboard-plus"></i> Admission Funnel</h5>
                <button class="btn btn-light btn-sm">
                    View All
                </button>
            </div>

            <div class="row text-center">
                <div class="col">
                    <h3>145</h3>
                    <span>Inqueries</span>
                </div>

                <div class="col">
                    <h3>72</h3>
                    <span>Shortlisted</span>
                </div>

                <div class="col">
                    <h3>24</h3>
                    <span>Interviews</span>
                </div>

                <div class="col">
                    <h3>12</h3>
                    <span>Offers</span>
                </div>

                <div class="col">
                    <h3>9</h3>
                    <span>Joined</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-xl-12">
        <div class="dashboard-card p-3 mt-3">
            <app-event-calendar></app-event-calendar>
        </div>
    </div>
</div>
